
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import Repeater from "@/components/Reusable/CustomInputs/Repeater/Repeater.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import { FocusPointOptions } from "@/types/controls";
import { ElementStudioContext } from "@/components/ElementStudio/ElementStudioTabsAndPanels.vue";
import AlertBox from "@/components/Reusable/CustomInputs/AlertBox.vue";

@Component({
  components: { AlertBox, DropdownInput, Repeater }
})
export default class ElementStudioVideoOptions extends Vue {
  @Inject("context") readonly context!: ElementStudioContext;

  @Prop()
  value!: FocusPointOptions | null;

  get internalValue() {
    return this.value || {};
  }

  get paths() {
    return this.context.getPathsToAllControls(["wpmedia"]);
  }

  updatePath(path: string) {
    this.emit({
      ...this.internalValue,
      imagePropertyPath: path || ""
    });
  }

  updateGridMode(gridMode: boolean) {
    this.emit({
      ...this.internalValue,
      gridMode
    });
  }

  emit(options: FocusPointOptions) {
    this.$emit("input", options);
  }
}
